var sharedGridCalculations = require('./shared/grid-calculations');
var sharedSeatLabel = require('./shared/seat-label');
var fabricSnapApply = require('./shared/fabric-snap-apply');
var sharedCssVars = require('./shared/css-vars');
var sharedObjectUtils = require('./shared/object-utils');

var readRootCssVar = sharedCssVars.readCssVar;
var cssColorWithAlpha = sharedCssVars.colorWithAlpha;
var snapshotFurnitureState = sharedObjectUtils.snapshotFurnitureState;
var isFurnishingObject = sharedObjectUtils.isFurnishingObject;

window.createGridLines = function (canvas, max_canvas_width, grid, outline_width, gridWidth, gridHeight)
{
    var headerCellSize = 40;

    var objects = canvas.getObjects();
    for (var i = objects.length - 1; i >= 0; i--) {
        if (objects[i]._isGridBadge) {
            canvas.remove(objects[i]);
        }
    }

    var pillWidth = 32;
    var pillHeight = 24;
    var pillMargin = 4;

    var pillWouldFit = (grid >= (pillWidth + pillMargin * 2));
    var badgeWidth, badgeHeight, badgeFontSize, badgeOffset;



    if (pillWouldFit) {
        badgeWidth = pillWidth;
        badgeHeight = pillHeight;
        badgeFontSize = 15;
        badgeOffset = (headerCellSize - badgeHeight) / 2;

    } else {
        badgeWidth = Math.max(20, Math.min(grid * 0.75, grid - 6));
        badgeHeight = badgeWidth;
        badgeFontSize = Math.max(10, Math.min(badgeWidth * 0.45, 18));
        badgeOffset = (headerCellSize - badgeHeight) / 2;

    }

    var lt = (typeof window !== 'undefined' && window.lightTheme) ? window.lightTheme : null;
    var accentMid = readRootCssVar('--accent-mid');
    var accentDarkest = readRootCssVar('--accent-darkest');
    var textMuted = readRootCssVar('--text-muted');
    var shadowStrong = readRootCssVar('--shadow-strong');
    var white = readRootCssVar('--white');
    var badgeColor = lt && lt.badge_fill ? lt.badge_fill : cssColorWithAlpha(accentMid, 0.13, readRootCssVar('--seat-member-highlight-bg'));
    var badgeStroke = lt && lt.badge_stroke ? lt.badge_stroke : cssColorWithAlpha(accentMid, 0.18, readRootCssVar('--seat-member-highlight-stroke'));
    var badgeTextColor = lt && lt.badge_text ? lt.badge_text : accentDarkest;
    var badgeShadow = new fabric.Shadow({ color: cssColorWithAlpha(shadowStrong, 0.78, readRootCssVar('--shadow-card')), blur: 4, offsetX: 0, offsetY: 1 });
    var gridLineColor = cssColorWithAlpha(textMuted, 0.2, readRootCssVar('--overlay-hover'));
    var gridLineDash = [4, 6];
    var outlineLineColor = lt && lt.badge_stroke ? lt.badge_stroke : cssColorWithAlpha(accentMid, 0.35, readRootCssVar('--seat-member-highlight-stroke'));
    var outlineLineWidth = 3;

    var width_ct = Math.max(1, Math.floor(gridWidth / grid));
    var height_ct = Math.max(1, Math.floor(gridHeight / grid));

    var canvasWidth = gridWidth + headerCellSize;
    var canvasHeight = gridHeight + headerCellSize;

    canvas.setWidth(canvasWidth);
    canvas.setHeight(canvasHeight);

    function addModernNumbering(text, left, top, isCol) {
        var bg;

        if (pillWouldFit) {
            bg = new fabric.Rect({
                left: left + (isCol ? grid/2 - badgeWidth/2 : (headerCellSize-badgeWidth)/2),
                top: top + (isCol ? badgeOffset : grid/2 - badgeHeight/2),
                width: badgeWidth,
                height: badgeHeight,
                rx: badgeHeight/2,
                ry: badgeHeight/2,
                fill: badgeColor,
                stroke: badgeStroke,
                strokeWidth: 1,
                selectable: false,
                evented: false,
                hasControls: false,
                hasBorders: false,
                lockMovementX: true,
                lockMovementY: true,
                lockRotation: true,
                lockScalingX: true,
                lockScalingY: true,
                shadow: badgeShadow,
                _isGridBadge: true,
                keep_object: true
            });
        } else {
            bg = new fabric.Circle({
                left: left + (isCol ? grid/2 - badgeWidth/2 : (headerCellSize-badgeWidth)/2),
                top: top + (isCol ? badgeOffset : grid/2 - badgeHeight/2),
                radius: badgeWidth/2,
                fill: badgeColor,
                stroke: badgeStroke,
                strokeWidth: 1,
                selectable: false,
                evented: false,
                hasControls: false,
                hasBorders: false,
                lockMovementX: true,
                lockMovementY: true,
                lockRotation: true,
                lockScalingX: true,
                lockScalingY: true,
                shadow: badgeShadow,
                _isGridBadge: true,
                keep_object: true
            });
        }

        var label = new fabric.Text(text, {
            left: left + (isCol ? grid/2 : headerCellSize/2),
            top: top + (isCol ? headerCellSize/2 : grid/2),
            fontSize: badgeFontSize,
            fontFamily: readRootCssVar('--font-sans', "'Work Sans', sans-serif"),
            fill: badgeTextColor,
            fontWeight: 'bold',
            originX: 'center',
            originY: 'center',
            selectable: false,
            evented: false,
            hasControls: false,
            hasBorders: false,
            lockMovementX: true,
            lockMovementY: true,
            lockRotation: true,
            lockScalingX: true,
            lockScalingY: true,
            _isGridBadge: true,
            keep_object: true
        });
        canvas.add(bg);
        canvas.add(label);
    }

    canvas.add(new fabric.Rect({
        left: 0,
        top: 0,
        width: canvasWidth,
        height: headerCellSize,
        fill: white,
        selectable: false,
        evented: false
    }));
    canvas.add(new fabric.Rect({
        left: 0,
        top: 0,
        width: headerCellSize,
        height: canvasHeight,
        fill: white,
        selectable: false,
        evented: false
    }));
    canvas.add(new fabric.Line([headerCellSize, headerCellSize, canvasWidth, headerCellSize], {
        stroke: outlineLineColor,
        strokeWidth: outlineLineWidth,
        selectable: false,
        evented: false
    }));
    canvas.add(new fabric.Line([headerCellSize, headerCellSize, headerCellSize, canvasHeight], {
        stroke: outlineLineColor,
        strokeWidth: outlineLineWidth,
        selectable: false,
        evented: false
    }));

    for(var x=0;x<width_ct;x++) {
        var show_col_name = (x+1).toString();
        var left_size = headerCellSize + (grid * x);
        addModernNumbering(show_col_name, left_size, 0, true);
        var line = new fabric.Line([
            left_size,
            headerCellSize,
            left_size,
            canvasHeight
        ], {
            type:'line',
            stroke: gridLineColor,
            strokeWidth: 1,
            selectable: false,
            evented: false,
            strokeDashArray: gridLineDash
        });
        canvas.add(line);
    }
    var last_vline = new fabric.Line([
        headerCellSize + (grid * width_ct),
        headerCellSize,
        headerCellSize + (grid * width_ct),
        canvasHeight
    ], {
        type:'line',
        stroke: gridLineColor,
        strokeWidth: 1,
        selectable: false,
        evented: false,
        strokeDashArray: gridLineDash
    });
    canvas.add(last_vline);

    for(var y=0;y<height_ct;y++) {
        var show_row_name = sharedGridCalculations.numberToLetter(y);
        var top_size = headerCellSize + (grid * y);
        addModernNumbering(show_row_name, 0, top_size, false);
        var line = new fabric.Line([
            headerCellSize,
            top_size,
            canvasWidth,
            top_size
        ], {
            type: 'line',
            stroke: gridLineColor,
            strokeWidth: 1,
            selectable: false,
            evented: false,
            strokeDashArray: gridLineDash
        });
        canvas.add(line);
    }
    var last_hline = new fabric.Line([
        headerCellSize,
        headerCellSize + (grid * height_ct),
        canvasWidth,
        headerCellSize + (grid * height_ct)
    ], {
        type: 'line',
        stroke: gridLineColor,
        strokeWidth: 1,
        selectable: false,
        evented: false,
        strokeDashArray: gridLineDash
    });
    canvas.add(last_hline);
}

window.numberToLetter = function (number) {
    return sharedGridCalculations.numberToLetter(number);
};

window.createId = function () {
    var min = 99;
    var max = 9999999;
    var random = Math.floor(Math.random() * (max - min + 1)) + min;
    return String(new Date().getTime() + random);
}

window.addSeatObject = function (loaded_from_dbase, x_location, y_location, box_size, seat_color, locked, layout_id, person_name, floor_plan_seat_id, selectable) {
    return window.canvasRenderer.addSeatObject(loaded_from_dbase, x_location, y_location, box_size, seat_color, locked, layout_id, person_name, floor_plan_seat_id, selectable);
};

window.addStructureObject = function (box_size, furniture_color, x_location, y_location, width_size, height_size, locked, id) {
    return window.canvasRenderer.addStructureObject(box_size, furniture_color, x_location, y_location, width_size, height_size, locked, id);
};

window.addTextBoxObject = function (box_size, word_color, text_val, x_location = "", y_location = "", width_size = "", height_size = "", locked = false, id = null) {
    if (id === null)
    {
        id = createId();
    }

    if(x_location === "")
    {
        x_location = box_size;
    }
    if(y_location === "")
    {
        y_location = box_size;
    }
    if(width_size === "")
    {
        width_size = box_size * 2;
    }
    if(height_size === "")
    {
        height_size = box_size * 2;
    }

    var new_text = new fabric.Textbox(text_val, {
        left: x_location,
        top: y_location,
        width: width_size,
        height: height_size,
        textAlign: 'center',
        fontSize: 20,
        fontFamily: 'Work Sans, serif',
        type: 'rectangle',
        fill: word_color,
        backgroundColor: 'transparent',
        stroke: '',
        originX: 'left',
        originY: 'top',
        id: id,
        hasRotatingPoint: false,
        lockMovementX: locked,
        lockMovementY: locked,
        selectable: !locked,
    });
    canvas.add(new_text);
}

window.deleteList = function (listItems) {
    if(listItems !== undefined) {
        var len = listItems.length;
        var list = []
        for(var i = 0; i < len; i+= 1) {
            var item = listItems[i];
            if(item.keep_object) continue;
            if (item.type !== "line") {
                list.push(item);
            }
        }
        len = list.length;
        for(var i = 0; i < len; i+= 1) {
            canvas.remove(list[i]);
        }
    }
}

window.compute_grid_width_height_square = function (grid_width_qty, grid_height_qty, max_canvas_width)
{
    var pass_vals = [];
    pass_vals['grid_sq_size'] = Math.ceil(max_canvas_width / Math.max(grid_width_qty, grid_height_qty));
    pass_vals['new_canvas_width'] = pass_vals['grid_sq_size'] * grid_width_qty;
    pass_vals['new_canvas_height'] = pass_vals['grid_sq_size'] * grid_height_qty;
    return pass_vals;
}

function computeResizeActions(old_grid_size_arr, new_grid_size_arr) {
    var width_action = old_grid_size_arr['width'] === new_grid_size_arr['width'] ? 'same'
        : new_grid_size_arr['width'] > old_grid_size_arr['width'] ? 'center' : 'center_and_check';

    var height_action = old_grid_size_arr['height'] === new_grid_size_arr['height'] ? 'same'
        : new_grid_size_arr['height'] > old_grid_size_arr['height'] ? 'same' : 'same_and_check';

    return { width_action: width_action, height_action: height_action };
}

function rebuildCanvas(new_grid_size_arr, max_canvas_width, outline_width) {
    var new_grid_width = new_grid_size_arr['width'];
    var new_grid_height = new_grid_size_arr['height'];
    var width_vals = compute_grid_width_height_square(new_grid_width, new_grid_height, max_canvas_width);
    var canvas_width = width_vals['new_canvas_width'];
    var canvas_height = width_vals['new_canvas_height'];
    var new_grid_sq_size = width_vals['grid_sq_size'];

    canvas = new fabric.Canvas('floor-plan-canvas', { selection: true, selectionKey: "ctrlKey" });
    window.canvas = canvas;
    if (window.canvasRenderer) window.canvasRenderer.updateConfig({ canvas: canvas });
    canvas.setWidth(canvas_width + outline_width);
    canvas.setHeight(canvas_height + outline_width);
    createGridLines(canvas, max_canvas_width, new_grid_sq_size, outline_width, canvas_width, canvas_height);

    return { canvas_width: canvas_width, canvas_height: canvas_height, new_grid_sq_size: new_grid_sq_size, new_grid_width: new_grid_width, new_grid_height: new_grid_height };
}

function correctObjectOverflow(new_grid_sq_size, outline_width, grid_width, grid_height) {
    var grid_width_px = grid_width * new_grid_sq_size;
    var grid_height_px = grid_height * new_grid_sq_size;
    var canvas_right = grid_width_px + outline_width;

    var cirObjects = canvas.getObjects('circle').filter(function (obj) { return !obj._isGridBadge; });
    for (var i = 0; i < cirObjects.length; i++) {
        if (cirObjects[i].left >= canvas_right) {
            var next_location = getNextSeatLocationNew("resize", new_grid_sq_size, outline_width, grid_width_px, grid_height_px, null, null, cirObjects[i].top);
            cirObjects[i].left = next_location['x_location'];
            cirObjects[i].top = next_location['y_location'];
            cirObjects[i].setCoords();
            canvas.renderAll();
        }
    }

    var rectObjects = canvas.getObjects('rectangle').filter(function (obj) { return obj.selectable === true && !obj._isGridBadge; });
    for (var i = 0; i < rectObjects.length; i++) {
        if (isFurnishingObject(rectObjects[i])) {
            var location = { x_location: rectObjects[i].left, y_location: rectObjects[i].top };

            do {
                location = resizeFurnishingCheckOnTop(rectObjects[i], location, new_grid_sq_size, outline_width, grid_width_px, grid_height_px);
            } while (location['check_move'] === true);

            if (!location['overflow']) {
                rectObjects[i].left = location['x_location'];
                rectObjects[i].top = location['y_location'];
                rectObjects[i].setCoords();
                canvas.renderAll();
            }
        }
    }
}

function registerResizeCanvasEvents(outline_width, new_grid_sq_size) {
    var start_left, start_top, activeSelection;

    canvas.on('selection:created', function (e) {
        e.target.set({ hasRotatingPoint: false });
    });

    canvas.on('mouse:down', function (e) {
        activeSelection = e.target;
        if (activeSelection !== null) {
            start_left = activeSelection.left;
            start_top = activeSelection.top;
        }
    });

    canvas.on('object:moving', function (options) {
        var grid_width_px = grid_width * new_grid_sq_size;
        var grid_height_px = grid_height * new_grid_sq_size;
        var new_left = Math.round((options.target.left - outline_width) / box_size) * box_size + outline_width;
        var new_top = Math.round((options.target.top - outline_width) / box_size) * box_size + outline_width;
        var is_outside;

        if (options.target.type === 'rectangle') {
            if (!isFurnishingObject(options.target)) return;
            is_outside = checkDropOutside("rectangle", start_left, start_top, new_top, new_left, grid_height_px, grid_width_px, outline_width, options.target.width, options.target.height);
            if (is_outside !== null) {
                new_left = is_outside['start_left'];
                new_top = is_outside['start_top'];
                options.target.set({ left: new_left, top: new_top });
            }
        }

        if (options.target.type === 'circle' || options.target.type === 'group') {
            is_outside = checkDropOutside("circle", start_left, start_top, new_top, new_left, grid_height_px, grid_width_px, outline_width);
            if (is_outside !== null) {
                new_left = is_outside['start_left'];
                new_top = is_outside['start_top'];
            }
            new_left += 1;
            new_top += 1;
        }

        options.target.set({ left: new_left, top: new_top });
    });

    canvas.on('object:modified', function (options) {
        if (!isFurnishingObject(options.target)) return;

        var minSize = box_size;
        var currentWidth = options.target.getScaledWidth();
        var currentHeight = options.target.getScaledHeight();
        var newWidth = Math.max(Math.round(currentWidth / box_size) * box_size, minSize);
        var newHeight = Math.max(Math.round(currentHeight / box_size) * box_size, minSize);

        options.target.set({
            width: newWidth, height: newHeight, scaleX: 1, scaleY: 1,
            left: options.target.left, top: options.target.top
        });
    });

    canvas.on('object:scaling', function (options) {
        if (!isFurnishingObject(options.target)) return;

        var minSize = box_size;
        var currentWidth = options.target.getScaledWidth();
        var currentHeight = options.target.getScaledHeight();

        if (currentWidth < minSize || currentHeight < minSize) {
            options.target.set({
                scaleX: Math.max(options.target.scaleX, minSize / options.target.width),
                scaleY: Math.max(options.target.scaleY, minSize / options.target.height)
            });
        }
    });
}

function resizedX(layout, widthAction, oldSqSize, newSqSize, oldSizes, newSizes, canvasWidth, outlineWidth) {
    var col = (layout['x_location'] - outlineWidth) / oldSqSize;
    if (widthAction === 'same') return col * newSqSize + outlineWidth;
    var diff = Math.floor((newSizes['width'] - oldSizes['width']) / 2);
    var x = col * newSqSize + diff * newSqSize + outlineWidth;
    x = Math.max(outlineWidth, x);
    if ((x + (layout['width'] || 0)) > (canvasWidth + outlineWidth)) {
        x = canvasWidth + outlineWidth - (layout['width'] || 0);
    }
    return Math.max(outlineWidth, x);
}

function resizedY(layout, oldSqSize, newSqSize, outlineWidth, subtractOne) {
    var base = subtractOne ? layout['y_location'] - 1 : layout['y_location'];
    var row = (base - outlineWidth) / oldSqSize;
    return row * newSqSize + outlineWidth;
}

window.resizeGrid = function (old_grid_size_arr, new_grid_size_arr, old_grid_square_size, max_canvas_width, outline_width, seat_color, furniture_color, word_color)
{
    var objects = canvas.getObjects();
    for (var i = objects.length - 1; i >= 0; i--) {
        if (objects[i]._isGridBadge) canvas.remove(objects[i]);
    }
    canvas.clear();
    canvas.dispose();

    var actions = computeResizeActions(old_grid_size_arr, new_grid_size_arr);
    var width_action = actions.width_action;
    var height_action = actions.height_action;

    var dims = rebuildCanvas(new_grid_size_arr, max_canvas_width, outline_width);
    var canvas_width = dims.canvas_width;
    var canvas_height = dims.canvas_height;
    var new_grid_sq_size = dims.new_grid_sq_size;
    var new_grid_width = dims.new_grid_width;
    var new_grid_height = dims.new_grid_height;

    layouts.forEach(function(layout) {
        var x, y;
        if (layout['item_type'] === 'circle') {
            x = resizedX(layout, width_action, old_grid_square_size, new_grid_sq_size, old_grid_size_arr, new_grid_size_arr, canvas_width, outline_width);
            if (width_action !== 'same') x -= 1;
            y = resizedY(layout, old_grid_square_size, new_grid_sq_size, outline_width, true);
            addSeatObject(false, x, y, new_grid_sq_size, seat_color, false, layout['seat_id']);
        } else if (layout['item_type'] === 'rectangle') {
            x = resizedX(layout, width_action, old_grid_square_size, new_grid_sq_size, old_grid_size_arr, new_grid_size_arr, canvas_width, outline_width);
            y = resizedY(layout, old_grid_square_size, new_grid_sq_size, outline_width, false);
            if (isEmpty(layout['item_text'])) {
                var new_width  = (layout['width']  / old_grid_square_size) * new_grid_sq_size;
                var new_height = (layout['height'] / old_grid_square_size) * new_grid_sq_size;
                addStructureObject(new_grid_sq_size, furniture_color, x, y, new_width, new_height, false, layout['seat_id']);
            } else {
                addTextBoxObject(new_grid_sq_size, word_color, layout['item_text'], x, y, layout['width'], layout['height'], false, layout['seat_id']);
            }
        }
    });

    if (width_action === "center_and_check" || height_action === "same_and_check") {
        correctObjectOverflow(new_grid_sq_size, outline_width, new_grid_width, new_grid_height);
    }

    if (typeof box_size !== 'undefined') {
        box_size = new_grid_sq_size;
    }

    canvas.renderAll();
    registerResizeCanvasEvents(outline_width, new_grid_sq_size);
}

window.resizeFurnishingCheckOnTop = function (passedObject, location, new_grid_sq_size, outline_width, grid_width, grid_height)
{
    var furnishing_top = location['y_location'];
    var furnishing_bottom = location['y_location'] + passedObject['height'];
    var furnishing_left = location['x_location'];
    var furnishing_right = location['x_location'] + passedObject['width'];
    var check_height, check_width, object_top, object_left;
    var existing_left, existing_right, existing_top, existing_bottom;
    var left_border, right_border, top_border, bottom_border;

    var cirObjects = canvas.getObjects('circle').filter(obj => !obj._isGridBadge);
    for (var i = 0; i < cirObjects.length; i++) {
        check_height = false;
        check_width = false;

        object_top = cirObjects[i].top + (cirObjects[i].height / 2);
        object_left = cirObjects[i].left + (cirObjects[i].width / 2);

        if (furnishing_top < object_top && furnishing_bottom > object_top) check_height = true;
        if (furnishing_left < object_left && furnishing_right > object_left) check_width = true;

        if (check_height && check_width) {
            location['check_move'] = true;
            location['x_location'] = location['x_location'] + new_grid_sq_size;

            if ((location['x_location'] + passedObject['width']) > (grid_width + outline_width)) {
                location['x_location'] = outline_width;
                location['y_location'] = location['y_location'] + new_grid_sq_size;
            }
            return location;
        }
    }
    var rectObjects = canvas.getObjects('rectangle').filter(obj => obj.selectable === true && !obj._isGridBadge);
    for (var i = 0; i < rectObjects.length; i++) {
        if (isFurnishingObject(rectObjects[i]) && rectObjects[i].id !== passedObject['id']) {
            left_border = rectObjects[i].left;
            right_border = rectObjects[i].left + rectObjects[i].width;
            top_border = rectObjects[i].top;
            bottom_border = rectObjects[i].top + rectObjects[i].height;

            if ((location['y_location'] + passedObject['height']) > (grid_height + outline_width)) {
                location['overflow'] = true;
                location['check_move'] = false;
                return location;
            } else if (left_border <= location['x_location'] && right_border > location['x_location'] && top_border <= location['y_location'] && bottom_border > location['y_location']) {
                location['check_move'] = true;
                location['x_location'] = location['x_location'] + new_grid_sq_size;

                if ((location['x_location'] + passedObject['width'] + new_grid_sq_size) > (grid_width + outline_width)) {
                    location['x_location'] = outline_width;
                    location['y_location'] = location['y_location'] + new_grid_sq_size;
                }
                return location;
            }
        }
    }

    location['check_move'] = false;

    return location;
}

window.getNextSeatLocationNew = function (location_type, box_size, outline_width, outside_width, outside_height, clone = null, paste_count = null, y_start_location = null)
{
    var location = {};
    location['x_location'] = outline_width + 1;
    location['y_location'] = outline_width + 1;

    switch(location_type){
        case "add":
            var actObj = canvas.getActiveObject('circle');
            if(actObj !== null && actObj !== undefined) {
                if(actObj.type === "circle"){
                    location['x_location'] = actObj.left + box_size - 1;
                    location['y_location'] = actObj.top - 1;
                }
            }
            break;
        case "paste":
            var new_top = clone.top + (box_size * paste_count);

            location['x_location'] = clone.left;
            location['y_location'] = new_top;
            break;
        case "resize":
            location['y_location'] = y_start_location;
            break;
        default:
            return null;
    }

    do {
        location = checkForObjectInLocation(location_type, location, box_size, outline_width, outside_width);
    }
    while (location['check_move'] === true);
    if(location_type === "add")
    {
        if(location['y_location'] > outside_height)
        {
            return null;
        }
    }

    return location;
}

window.checkForObjectInLocation = function (check_type, location, box_size, outline_width = null, outside_width = null)
{
    var cirObjects, tmp_x_location, tmp_y_location, rectObjects;
    var left_border, right_border, top_border, bottom_border;

    location['check_move'] = false;

    if(check_type === "add")
    {
        if(location['x_location'] > outside_width)
        {
            location['y_location'] =  location['y_location'] + box_size;
            location['x_location'] =  outline_width;
        }
    }

    cirObjects = canvas.getObjects('circle').filter(obj => !obj._isGridBadge);
    for (var i = 0; i < cirObjects.length; i++) {
        tmp_x_location = location['x_location'];
        tmp_y_location = location['y_location'];

        if (check_type === "add") {
            tmp_x_location += 1;
            tmp_y_location += 1;
        }

        if (check_type === "resize") {
            if (cirObjects[i].left === tmp_x_location && cirObjects[i].top === tmp_y_location) {
                location['check_move'] = true;
                location['x_location'] = location['x_location'] + box_size;
                return location;
            }
            if (tmp_x_location > outside_width) {
                location['check_move'] = true;
                location['x_location'] = outline_width + 1;
                location['y_location'] = location['y_location'] + box_size;
                return location;
            }
        } else {
            if (cirObjects[i].left === tmp_x_location && cirObjects[i].top === tmp_y_location) {
                location['check_move'] = true;
                if (check_type === "add") location['x_location'] = location['x_location'] + box_size;
                if (check_type === "paste") location['y_location'] = location['y_location'] + box_size;
                return location;
            }
        }
    }

    rectObjects = canvas.getObjects('rectangle').filter(obj => obj.selectable === true && !obj._isGridBadge);
    for (var i = 0; i < rectObjects.length; i++) {
        if (isFurnishingObject(rectObjects[i])) {
            left_border = rectObjects[i].left;
            right_border = rectObjects[i].left + rectObjects[i].width;
            top_border = rectObjects[i].top;
            bottom_border = rectObjects[i].top + rectObjects[i].height;

            if (check_type === "resize") {
                if (left_border <= location['x_location'] && right_border > location['x_location'] && top_border <= location['y_location'] && bottom_border > location['y_location']) {
                    location['check_move'] = true;
                    location['x_location'] = location['x_location'] + box_size;
                    return location;
                }
                if (left_border > outside_width) {
                    location['check_move'] = true;
                    location['x_location'] = outline_width + 1;
                    location['y_location'] = location['y_location'] + box_size;
                    return location;
                }
            } else {
                if (left_border <= location['x_location'] && right_border > location['x_location'] && top_border <= location['y_location'] && bottom_border > location['y_location']) {
                    location['check_move'] = true;
                    if (check_type === "add") location['x_location'] = right_border;
                    if (check_type === "paste") location['y_location'] = bottom_border + 1;
                    return location;
                }
            }
        }
    }

    return location;
}

window.checkDropOutside = function (object_type, start_left, start_top, new_top, new_left, canvas_height, canvas_width, outline_width, rectangle_width = null, rectangle_height = null)
{
    var location = {};

    if(object_type === "circle")
    {
        if(new_top > canvas_height || new_top < outline_width || new_left < outline_width || new_left > canvas_width){
            showAlertMsg('The seat can not be moved outside the layout.  It has been moved back to where you started', 'danger');
            location['start_left'] = start_left - 1;
            location['start_top'] = start_top - 1;
            return location;
        }
    }
    if(object_type === "rectangle")
    {
        if(new_top < outline_width || (new_top + rectangle_height) > (canvas_height + outline_width) || new_left < outline_width || (new_left + rectangle_width) > (canvas_width + outline_width))
        {
            showAlertMsg('The furnishing or label can not be moved outside the layout.  It has been moved back to where you started', 'danger');
            location['start_left'] = start_left;
            location['start_top'] = start_top;
            return location;
        }
    }
    return null;
}

function syncCanvasRendererFromWindowGlobals(furnitureColorOverride) {
    if (typeof window.canvasRenderer === 'undefined') {
        return;
    }
    var hc = typeof window.headerCellSize !== 'undefined'
        ? window.headerCellSize
        : (window.gridPositioning && window.gridPositioning.headerCellSize) || 40;
    var config = {
        canvas: window.canvas,
        boxSize: typeof window.box_size !== 'undefined' ? window.box_size : 50,
        gridWidth: typeof window.grid_width !== 'undefined' ? window.grid_width : 999,
        gridHeight: typeof window.grid_height !== 'undefined' ? window.grid_height : 999,
        headerCellSize: hc,
        seatColor: typeof window.seat_color !== 'undefined' ? window.seat_color : readRootCssVar('--gray-200')
    };
    if (furnitureColorOverride !== undefined && furnitureColorOverride !== null) {
        config.furnitureColor = furnitureColorOverride;
    } else if (typeof window.furniture_color !== 'undefined') {
        config.furnitureColor = window.furniture_color;
    }
    if (typeof window.word_color !== 'undefined') {
        config.wordColor = window.word_color;
    }
    window.canvasRenderer.updateConfig(config);
}

window.applySeatGridAlignment = function (obj, targetLeft, targetTop) {
    if (typeof window.canvasRenderer !== 'undefined' && window.canvasRenderer) {
        syncCanvasRendererFromWindowGlobals();
        return window.canvasRenderer.applySeatGridAlignment(obj, targetLeft, targetTop);
    }
    if (typeof targetLeft === 'undefined') targetLeft = obj.left;
    if (typeof targetTop === 'undefined') targetTop = obj.top;
    var w = (obj.width * (obj.scaleX || 1)) || (typeof box_size !== 'undefined' ? box_size : 50);
    var h = (obj.height * (obj.scaleY || 1)) || w;
    var headerCellSize = (window.gridPositioning && window.gridPositioning.headerCellSize) || 40;
    var boxSz = typeof box_size !== 'undefined' ? box_size : 50;
    var gw = typeof grid_width !== 'undefined' ? grid_width : 999;
    var gh = typeof grid_height !== 'undefined' ? grid_height : 999;
    var snap = sharedGridCalculations.computeSeatSnapPixels(targetLeft, targetTop, w, h, headerCellSize, boxSz, gw, gh);
    return fabricSnapApply.applySeatSnapToFabricObject(obj, snap);
};

window.applyFurnitureGridAlignment = function (obj, targetLeft, targetTop, targetWidth, targetHeight) {
    if (typeof window.canvasRenderer !== 'undefined' && window.canvasRenderer) {
        syncCanvasRendererFromWindowGlobals();
        return window.canvasRenderer.applyFurnitureGridAlignment(obj, targetLeft, targetTop, targetWidth, targetHeight);
    }
    if (typeof targetLeft === 'undefined') targetLeft = obj.left;
    if (typeof targetTop === 'undefined') targetTop = obj.top;
    if (typeof targetWidth === 'undefined') targetWidth = obj.width * (obj.scaleX || 1);
    if (typeof targetHeight === 'undefined') targetHeight = obj.height * (obj.scaleY || 1);
    var headerCellSize = (window.gridPositioning && window.gridPositioning.headerCellSize) || 40;
    var boxSz = typeof box_size !== 'undefined' ? box_size : 50;
    var gw = typeof grid_width !== 'undefined' ? grid_width : 999;
    var gh = typeof grid_height !== 'undefined' ? grid_height : 999;
    var snap = sharedGridCalculations.computeFurnitureSnapLayout(
        targetLeft,
        targetTop,
        targetWidth,
        targetHeight,
        headerCellSize,
        boxSz,
        gw,
        gh
    );
    return fabricSnapApply.applyFurnitureSnapToFabricObject(obj, snap);
};

window.createOptimizedSeatLabel = function (personName, boxSize, radiusSize) {
    var fill = typeof window.word_color !== 'undefined' ? window.word_color : readRootCssVar('--text-color');
    return sharedSeatLabel.createOptimizedSeatLabel(personName, boxSize, radiusSize, fill);
};


window.cleanupCanvasBeforeNavigation = function () {
    try {
        $('#memberSidebarCol, #seatingChartCol').css('transition', 'none');

        if (typeof canvas !== 'undefined' && canvas) {
            if (canvas.clear) {
                canvas.clear();
            }
            if (canvas.dispose) {
                canvas.dispose();
            }
            canvas = null;
        }

        if (typeof window.canvas !== 'undefined') {
            window.canvas = null;
        }
        window.gridHoverSelectionInitialized = false;
        if (typeof window.box_size !== 'undefined') {
            delete window.box_size;
        }
        if (typeof window.grid_width !== 'undefined') {
            delete window.grid_width;
        }
        if (typeof window.grid_height !== 'undefined') {
            delete window.grid_height;
        }

        if (typeof window.pendingAssignments !== 'undefined') {
            window.pendingAssignments = [];
        }
        if (typeof window.pendingRemovals !== 'undefined') {
            window.pendingRemovals = [];
        }

        if (typeof isDragging !== 'undefined') {
            isDragging = false;
        }
    } catch (error) {
        console.warn('Error during canvas cleanup:', error);
    }
}

window.roundTo2DecimalPlaces = (val) => Number(val.toFixed(2));

/* Bootstrap modal body cleanup (also in functions.js for manager/member shells). */
(function initSeatingBootstrapModalBodyCleanup() {
    if (typeof window.initBootstrapModalBodyCleanup === 'function') {
        window.initBootstrapModalBodyCleanup();
        return;
    }
    function cleanupBootstrapModalBody() {
        if (!$ || $('.modal.show').length > 0) {
            return;
        }
        $('body').removeClass('modal-open').css({ paddingRight: '', overflow: '' });
        $('.modal-backdrop').remove();
    }
    $(function () {
        $(document).on('hidden.bs.modal', '.modal', cleanupBootstrapModalBody);
        if ($.fn.modal && !$.fn.modal.__bodyCleanupPatched) {
            const bsModal = $.fn.modal;
            $.fn.modal = function (option, ...rest) {
                const result = bsModal.apply(this, arguments);
                if (option === 'hide') {
                    setTimeout(cleanupBootstrapModalBody, 0);
                }
                return result;
            };
            $.fn.modal.__bodyCleanupPatched = true;
        }
    });
    window.cleanupBootstrapModalBody = cleanupBootstrapModalBody;
})();
